import { useCallback, useEffect, useState } from "react";

export default function useLocalStorageState(key, initial) {
    const [value, setValue] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw == null ? initial : JSON.parse(raw);
        } catch {
            return initial;
        }
    });

    const set = useCallback(
        (next) => {
            setValue(next);
            try {
                localStorage.setItem(key, JSON.stringify(next));
            } catch {
                // ignore
            }
        },
        [key]
    );

    useEffect(() => {
        const handler = (e) => {
            if (e.key === key) {
                try {
                    setValue(e.newValue == null ? initial : JSON.parse(e.newValue));
                } catch {
                    setValue(initial);
                }
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, [key, initial]);

    return [value, set];
}
